import { api } from './client';
import type {
  MetadatiGriglia,
  RichiestaGriglia,
  RisultatoGriglia,
  ValoreDistinto,
} from '../lib/tipi';

export const griglie = {
  metadati: (nome: string) => api.get<MetadatiGriglia>(`/griglie/${nome}/colonne`),

  righe: <T = Record<string, unknown>>(nome: string, richiesta: RichiestaGriglia) =>
    api.post<RisultatoGriglia<T>>(`/griglie/${nome}`, richiesta),

  valoriDistinti: (nome: string, colonna: string, contesto: RichiestaGriglia) =>
    api.post<ValoreDistinto[]>(`/griglie/${nome}/valori/${colonna}`, contesto),
};
